import { useGlobalization } from '../../../../contexts';
import { DateTime } from 'luxon';
import React, { useEffect } from 'react';
import { TimeSpan, Body, Title } from './AboutToExpire.styles';
import { formatDuration } from '../../../../utils';

export interface AboutToExpireBodyProps {
	readonly expiryDate: DateTime;
}

// Separate component for avoiding forcing the user to logout when the component is unmounted
export default function AboutToExpireBody({
	expiryDate,
}: AboutToExpireBodyProps): JSX.Element {
	const expireTime = useCountdown(expiryDate);
	const { t } = useGlobalization();

	return (
		<>
			<Title>
				{t('For your security, you will be logged out in ')}
				<TimeSpan>{JSON.stringify(expireTime)}</TimeSpan>
			</Title>
			<Body>
				{t(
					'If you are still working and don’t want to end your session, click the extend session button below. Otherwise, your session will be closed and you will be logged out.',
				)}
			</Body>
		</>
	);
}

function useCountdown(expiryDate: DateTime) {
	const [expireTime, setExpireTime] = React.useState<string>(
		expiryDate?.diffNow?.()?.toFormat('mm:ss') || '',
	);

	useEffect(() => {
		const interval = setInterval(() => {
			// Set timeout formatted string
			const diff = expiryDate?.diffNow();
			if (diff.milliseconds <= 0) {
				setExpireTime('00:00');
				clearInterval(interval);
				return;
			}
			setExpireTime(formatDuration(diff));
		}, 1000);
		return () => clearInterval(interval);
	}, [expiryDate]);

	return expireTime;
}
